/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidInvoiceUpload } from "../../clients/individualPaymentInvoicesController/postApiV1IndividualpaymentParcelsParcelidInvoiceUpload.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/parcels/:parcelId/invoice-upload" },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"];
      data?: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, data }) => {
      return postApiV1IndividualpaymentParcelsParcelidInvoiceUpload(
        parcelId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Aceita pdf/png/jpg/jpeg/bmp/tiff/tif; bloqueia se já há NFe em processamento; salva no armazenamento e vincula à parcela. Migrado do legado IndividualPayment/UploadInvoice. **(Requer Authorization para autenticação)**
 * @summary Anexa o arquivo da nota fiscal à parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoice-upload}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidInvoiceUpload<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"];
        data?: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"];
        data?: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"];
      data?: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"];
      data?: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest;
    },
    TContext
  >;
}
